import chroma from 'chroma-js'

const opalDefaultColor = '#222324' // $dark-surface-nd100;

const getColor = (hexString, amount) => {
  const amt = (amount * 10) / 2
  let color = chroma(hexString).darken(amt).hex() // Darken by default

  // If color cannot be darkened by given amount, it should lighten instead
  if (chroma(hexString).luminance() < amount) {
    color = chroma(hexString).brighten(amt).hex()
  }

  return color
}

const getEditorColors = (theme) => {
  const originalColor = theme.background_color || opalDefaultColor

  const editorColors = {
    backgroundColor: getColor(originalColor, 0.03),
    borderColor: getColor(originalColor, 0.2),
  }

  return editorColors
}

export { getEditorColors }

export default getEditorColors
